import { render, staticRenderFns } from "./ProviderReports.vue?vue&type=template&id=59b0e351&scoped=true&"
import script from "./ProviderReports.vue?vue&type=script&lang=js&"
export * from "./ProviderReports.vue?vue&type=script&lang=js&"
import style0 from "./ProviderReports.vue?vue&type=style&index=0&id=59b0e351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b0e351",
  null
  
)

export default component.exports